import React from 'react'

import styled from '@emotion/styled'
import { mq, black02, green01, text } from '../../_style'
import HeadingSet from '../molecules/headingSet';
import { css } from '@emotion/core';

const Container = styled.div`
  position: relative;
  ${mq.pc} {
    background-image: url(${props => props.bg});
    background-size: cover;
    background-position: center;
  }
  &::before {
    content: "";
    display: block;
    padding-top: ${560 / 1440 * 100}%;
    ${mq.pc} {
      min-height: 560px;
    }
    ${mq.sp} {
      padding-top: ${ 528 / 750 * 100}%;
      background-image: url(${props => props.bgSp});
      background-size: cover;
      background-position: center;
    }
  }
`
const InnerWrap = styled.div`
  ${mq.pc} {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 100%;
  }
  ${props => props.spTextInImg && `
    ${mq.sp} {
      position: absolute;
      top: 95px;
      left: 0;
      right: 0;
    }
  `}
`
const Inner = styled.div`
  position: relative;
  ${mq.pc} {
    max-width: 960px;
    height: 100%;
    margin: auto;
  }
  ${props => props.spTextInImg && `
    ${mq.sp} {
      h2 {
        text-shadow: 0px 2px 1px #fff;
      }
    }
  `}
`
export default class PageMain extends React.Component {
  render() {
    return(
      <Container bg={this.props.bg} bgSp={this.props.bgSp}>
        <InnerWrap>
          <Inner spTextInImg={this.props.spTextInImg}>
            <HeadingSet en={this.props.en} sub={this.props.sub} inPageMain isHistory={this.props.isHistory}>
              {this.props.children}
            </HeadingSet>
          </Inner>
        </InnerWrap>
      </Container>
    )
  }
}
